import { type CreateTimelineEventRequest, eventsApi } from '../../services/api';
import { icon } from '../../icons';
import { t, translateEventType } from '../../services/i18n';
import { esc } from './timeline-shared';

export function openTimelineAddDialog(tenantId: string, tenantName: string, onCreated: () => Promise<void>): void {
  const overlay = document.createElement('div');
  overlay.className = 'modal-overlay';
  const today = new Date().toISOString().split('T')[0];
  overlay.innerHTML = `
    <div class="modal">
      <div class="modal-header">
        <h2>${t('timeline.newEvent')}</h2>
        <button class="modal-close" data-action="cancel">${icon('x', { size: 20 })}</button>
      </div>
      ${tenantName ? `<p class="modal-subtitle">${t('common.tenant')}: <strong>${esc(tenantName)}</strong></p>` : ''}
      <form>
        <div class="form-group">
          <label>${t('common.type')} *</label>
          <select name="eventType" required>
            ${['MoveIn', 'MoveOut', 'Damage', 'Inspection', 'Indexation', 'Remark'].map((value) => `<option value="${value}">${translateEventType(value)}</option>`).join('')}
          </select>
        </div>
        <div class="form-group">
          <label>${t('common.title')} *</label>
          <input name="title" required placeholder="${t('timeline.titlePlaceholder')}">
        </div>
        <div class="form-group">
          <label>${t('common.date')} *</label>
          <input name="date" type="date" required value="${today}">
        </div>
        <div class="form-group">
          <label>${t('common.description')}</label>
          <textarea name="description" rows="3" placeholder="${t('timeline.descriptionPlaceholder')}"></textarea>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn btn-outline" data-action="cancel">${t('common.cancel')}</button>
          <button type="submit" class="btn btn-primary">${t('common.add')}</button>
        </div>
      </form>
    </div>
  `;
  const close = () => overlay.remove();
  overlay.addEventListener('click', (event) => { if (event.target === overlay) close(); });
  overlay.querySelectorAll('[data-action="cancel"]').forEach((button) => button.addEventListener('click', close));
  overlay.querySelector('form')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submitBtn = overlay.querySelector('[type="submit"]') as HTMLButtonElement;
    submitBtn.disabled = true;
    submitBtn.textContent = t('timeline.saving');
    const fd = new FormData(event.currentTarget as HTMLFormElement);
    const data: CreateTimelineEventRequest = {
      tenantId,
      title: fd.get('title') as string,
      description: (fd.get('description') as string) || undefined,
      date: fd.get('date') as string,
      eventType: fd.get('eventType') as string,
    };
    try {
      await eventsApi.create(data);
      close();
      await onCreated();
    } catch (error) {
      console.error('Failed to create event:', error);
      submitBtn.disabled = false;
      submitBtn.textContent = t('common.add');
    }
  });
  document.body.appendChild(overlay);
}
